import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import logo from "../../assets/img/logo.horizontal.allwhite.svg";

// Component styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logoContainer: {
      display: "flex",
      alignItems: "center",
      width: "200px",
      paddingBottom: "42px",
    },
    logoImg: {
      maxWidth: "100%",
      display: "block",
      height: "auto",
      maxHeight: "40px",
    },
  })
);

export const StackPanelLogo = () => {
  const classes = useStyles();

  return (
    <div className={classes.logoContainer}>
      <img
        src={logo}
        alt="StackCare Logo"
        className={classes.logoImg}
        draggable={false}
      />
    </div>
  );
};
